export const API_ENDPOINTS = {
    ICD: {
        GET_ICD_BY_ID: "ICD/GetById",
        SEARCH_ICD: "ICD/Search",
        SAVE_ICD: "/ICD/Save",
        UPDATE_ICD: "/ICD/Update",
        DELETE_ICD: "ICD/Delete",
        EXPORT_ICD: "ICD/Export",

  },
 
  // Add other modules like EMPLOYEE, DEPARTMENT etc.
};

export const QUERY_KEYS = {
    ICD: {
        ICD: ["SearchSearch"], // UNIQUE IN OVER ALL APPLICATION
  },
  
};